export default __webpack_public_path__ + "images/20caf5ca5946e2543cf7f225c9d1b402.svg";